import React from 'react';
import { StudentCalendar } from '../../../../../component/calendar/student-calendar/student-calendar';

export const StudentLecturesCalendar: React.FC<{ studentId: number }> = ({
  studentId,
}) => {
  return <StudentCalendar studentId={studentId} />;
};
